import { render, staticRenderFns } from "./accept-term.vue?vue&type=template&id=356a10d8&lang=pug&"
import script from "./accept-term.vue?vue&type=script&lang=js&"
export * from "./accept-term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports